<template>
	<div class="row">
		<div class="col-md-12 overflow">
			<v-lote :showFilter="false"></v-lote>
		</div>
	</div>
</template>
<script>

export default {
	data() {
		return {
			datePickerConfig: {
				'format': 'D/MM/YYYY',
				'showClose': true
			},
			pedidoBonificado: '',
			valor_pedido: 0,
			showLink: false,
			toDate: "",
			fromDate: "",
			status: "",
			lotes: [],
			lote: "",
			historicos: [],
			pages: 0,
			currentPage: 1,
			classe: null,
			total: 0,
			isLoading: true,
		}
	},
	methods: {
		initDates() {
			let m = moment();
			m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
			this.toDate = moment();
			this.toDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
			this.fromDate = m;
			this.fromDate.subtract(6, 'month');
		},
	},
	created() {
		this.initDates();
	}
}
</script>

<style scoped="">
.btn-search {
	margin-top: 25px;
}

.overflow {
	overflow: auto;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HomeDistribuidor.vue